module.exports = __webpack_public_path__ + "static/media/gender-male.84c59bcb.png";